import { ResponsiveBar } from "@nivo/bar";

export default function index({ data, isLoading }) {
  if (isLoading) return <div>Loading...</div>;

  return (
    <ResponsiveBar
      data={data}
      keys={["porcentaje"]}
      indexBy="canal"
      margin={{
        top: 40,
        right: 10,
        bottom: 0,
        left: 60
      }}
      padding={0.1}
      maxValue={100}
      groupMode="grouped"
      layout="horizontal"
      colors={{ scheme: "category10" }}
      borderRadius={4}
      borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
      axisTop={{
        tickSize: 0,
        tickPadding: 0,
        tickRotation: 0,
        legend: "Porcentaje de asistencia por canal",
        legendOffset: -30,
        legendPosition: "middle"
      }}
      axisRight={null}
      axisBottom={null}
      axisLeft={{
        tickSize: 0,
        tickPadding: 10,
        tickRotation: 0
      }}
      enableGridX
      label={(d) =>
        `${d.value}% (T=${d.data.total} A=${d.data.asistente} F=${d.data.total - d.data.asistente})`
      }
      enableGridY={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{ from: "color", modifiers: [["brighter", 10]] }}
      animate
      motionStiffness={90}
      motionDamping={15}
    />
  );
}
